import type { FaireProductEntity } from "../../entity_types/product";

export const p_ka7g8qr4ka: FaireProductEntity = {
  token: "p_ka7g8qr4ka",
  type: "product",
  name: "HealthSmart® Honey Mustard BBQ Sauce (6pk Case, Sugar Free)",
  brandToken: "b_7z3u3v384w",
  brandName: "Nature's Hollow",
  imageUrl:
    "https://cdn.faire.com/fastly/a2aa0559ee37902d8178187069067948694e569ad305589609481a765410b827.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/08a139d202d3e12100b5cf008ff26a5cd807d4dfd526ca0a614d01574acd896c.jpeg",
  ],
  priceDollars: 5,
  description:
    "Our unique sugar free barbeque sauces add a hearty flavor to red meats, chicken and fish. Unlike most barbeque sauces that are filled with corn syrups and sugars, Honey Mustard Barbeque Sauce is sugar-free and gluten-free. You’ll find many uses for this versatile sauce and its sweet, yet mildly smokey, mustard flavor is unbeaten on all meat.",
  tags: [],
  msrpDollars: 6.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:25:13.638Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
